import {GameQuest} from "../libs/GameQuest";

export class QuestService {
  questsData = [];
  questsMap = {};

  categories = [
    {id: 0, name: 'Main Quests', color: '#ffcc66'},
    {id: 1, name: 'Side Quests', color: '#ffff99'},
  ];

  isOpen = false;

  fontSize = 22;

  convStatus = {
    0: 'active',
    1: 'completed',
    2: 'failed',
    '-1': 'hidden',
    'hide': -1,
    'active': 0,
    'activate': 0,
    'completed': 1,
    'complete': 1,
    'failed': 2,
    'fail': 2,
  };

  statusEnum = {
    Active: 0,
    Completed: 1,
    Failed: 2,
    Hidden: -1,
  }

  questEnum = {
    CatFood: 3,
    AnimalShelter: 5,
    elenPackageQuest: 6,
    buyDrinkQuest: 7,
    helpDrunkenMother: 8,
    RubinaGymTip: 9,
    BirthdayGift: 12,
    EnergyDrink: 13,
    ItelligenceRise: 14,
    shampoo: 17
  };

  icons = {
    icon0: 163, // not complete icon
    icon1: 164, // complete icon
    icon2: 162, // failed icon
    icon3: 88 // tracked icon
  }

  #filePath = 'data/Quests.json';

  constructor() {
    this._loadFileData();
  }

  viewLog() {
    Yosemite.QuestLog.viewLog();
  }

  fail(questId) {
    this.create(questId);
    this.put(questId, 2);
  };
  // YsServices.questService.complete(6, true);
  // YsServices.questService.activate(6);

  complete(questId, showPopup = true) {
    this.create(questId);
    this.put(questId, 1);

    if(showPopup) {
      YsServices.notificationService.completeQuest();
    }
  };

  handleQuestItem() {
    const questItems = Yosemite.McManager.getQuestItemInventory();
    if (!questItems.length) return;

    let showPopup = false;
    for (let i = 0; i < questItems.length; i++) {
      const note = JSON.parse(questItems[i]['note']);
      if(note.questId === this.questEnum.EnergyDrink) {
        Yosemite.EventStateManager.state.waifu.vicky.dayEventChecked = false;
      }

      if(note.questId !== this.questEnum.EnergyDrink) {
        Yosemite.McManager.removeFromInventory(questItems[i].id);
        showPopup = true;
        this.complete(note.questId, true);
      }
    }
  };

  completeQuest(questId, showPopup, setWait) {
    if (setWait) {
      $gameMap._interpreter.wait(60);
    }

    this.complete(questId, showPopup);
  }

  activate(questId, showNotification = true) {
    this.create(questId);
    this.put(questId, 0);

    if(showNotification) {
      YsServices.notificationService.activateQuest();
    }
  }

  activateMany(questIds) {
    questIds.forEach((questId) => {
      this.create(questId);
      this.put(questId, 0);
    })
  }

  // Change quest status
  put(id, status = 0) {
    if(!$gameSystem._quests) return;

    const place = this.convStatus[status];

    if (status !== 0) $gameSystem._quests.tracked = null;
    if ($gameSystem._quests.quest[id]) {
      this.removeQuest(id);          // remove from all array
      $gameSystem._quests[place].unshift(id); // add to desired array
      $gameSystem._quests.quest[id]._status = status;  // set quest status
    }
  };

  // create quest if doesn't exist
  create(questId) {
    if(!$gameSystem._quests) return;

    if (!$gameSystem._quests.quest[questId] && this.questsMap[questId]) {
      this.removeQuest(questId);
      $gameSystem._quests.quest[questId] = new GameQuest(this.questsMap[questId]);
    }
  };

  // remove quest from active, completed or failed lists. Quest will still exist as obtained, however.
  removeQuest(questId) {
    if(!$gameSystem._quests.quest[questId]) return;

    this._sliceArray($gameSystem._quests.active, questId);
    this._sliceArray($gameSystem._quests.completed, questId);
    this._sliceArray($gameSystem._quests.failed, questId);
    $gameSystem._quests.quest[questId]._status = -1;
  };

  // change status of a category
  catStatus(id, status) {
    $gameSystem._quests.categoryActive[id] = status;
  };

  track(questId) {
    if ($gameSystem._quests.quest[questId] && $gameSystem._quests.quest[questId]._status === 0) {
      $gameSystem._quests.tracked = questId;
    } else {
      $gameSystem._quests.tracked = null;
    }
  };

  isTracked() {
    return $gameSystem._quests.tracked || 0;
  };

  // Change quest objective status
  objective(questId, objectiveId, status) {
    this.create(questId);
    if (isNaN(status)) status = this.convStatus[status];

    // status can be: 0 is not yet complete, 1 is completed, 2 is failed
    if ($gameSystem._quests.quest[questId]) {
      $gameSystem._quests.quest[questId]._objectives[objectiveId] = status;
    }
  };

  status(questId, _objective) {
    if ($gameSystem._quests && $gameSystem._quests.quest[questId]) {
      if (_objective !== undefined) {
        return $gameSystem._quests.quest[questId]._objectives[_objective];
      } else {
        return $gameSystem._quests.quest[questId]._status;
      }
    } else {
      return -1;
    }
  };

  isActive(questId) {
    return this.status(questId) === 0;
  }

  isCompleted(questId) {
    return this.status(questId) === 1;
  }

  resolution(questId, index) {
    if ($gameSystem._quests.quest[questId]) $gameSystem._quests.quest[questId]._resolution = index;
  };

  setupQuests() {
    for (const [key] of Object.entries($gameSystem._quests.quest)) {
      const questIndex = Number(key);
      $gameSystem._quests.quest[questIndex] = new GameQuest(this.questsMap[questIndex]);
      $gameSystem._quests.quest[questIndex]._status = this._checkQuestStatus(questIndex);
    }
  }

  _checkQuestStatus(key) {
    const active = $gameSystem._quests.active.indexOf(key);
    const completed = $gameSystem._quests.completed.indexOf(key);
    const failed = $gameSystem._quests.failed.indexOf(key);

    if(active !== -1) return 0;
    if(completed !== -1) return 1;
    if(failed !== -1) return 2;
    return -1;
  }

  _loadFileData() {
    if(this.questsData.length) return;

    const request = new XMLHttpRequest();
    request.open("GET", this.#filePath);
    request.overrideMimeType('application/json');
    request.onload = () => {
      if (request.status === 200) {
        this.questsData = JSON.parse(request.responseText);
        this.questsData.forEach(quest => this.questsMap[quest.id] = quest);
      }
    };

    request.send();
  }

  _sliceArray(array, element) {
    const index = array.indexOf(element);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
}

